import estoreOrder from "../services/estore.orders";
import notification from "../services/notification";
import advanceSearchHelper from "../services/advance.search.helper";
import _ from "lodash";
import { isJSON } from "../utilities";

export default {
    namespaced: true,
    state: {
        loading: false,
        orders: [],
        errors: null,
        maxPage: 1,
        nextPage: 0,
        prevPage: 0,
        currentPage: 1,
        searchableFields: [],
        statusSearchOptions: [],
        defaultStatusSearchOption: null,
        defaultSearchableFieldOption: null,
        searchKeyword: null,
        pagination: {
            currentPage: 1,
            prevPage: 0,
            nextPage: 0,
            maxPage: 0,
            totalPerPage: 1,
            currentFirstItem: 1,
            currentLastItem: 1,
            initialPageCount: 0,
            perPage: 10
        },
        modal: {
            view_order: {
                status: false
            },
            view_deposit_slip_image: {
                status: false
            }
        },
        orderDetails: null,
        depositSlipImage: null,
        orderTransactionUuid: null,
        paymentTypeOptions: null,
        logisticsTypeOptions: null,
        paymentExpressHistory: [],
        proofOfImage: {},
        pointsEarned: 0
    },
    mutations: {
        loading(state, value = true) {
            state.loading = value;
        },
        errors(state, errors) {
            state.errors = errors;
            state.loading = false;
        },
        resetErrors(state) {
            state.errors = null;
        },
        orders(state, list) {
            state.orders = list;
        },
        pagination(state, pagination) {
            state.maxPage = pagination.max_page;
            state.prevPage = pagination.prev_page;
            state.nextPage = pagination.next_page;
            state.currentPage = state.prevPage + 1;
        },
        setInitialPageCount(state, list) {
            state.pagination.initialPageCount = list.length;
        },
        setCurrentPage(state, page) {
            state.pagination.currentPage = page;
        },
        setPagination(state, pagination) {
            state.pagination.totalPerPage = pagination.list.length;
            state.pagination.maxPage =
                state.pagination.totalPerPage > 0 ? pagination.max_page : 0;
            state.pagination.prevPage = pagination.prev_page;
            state.pagination.nextPage = pagination.next_page;
            state.pagination.currentPage = state.pagination.prevPage + 1;
            state.pagination.currentFirstItem =
                state.pagination.totalPerPage > 0
                    ? state.pagination.initialPageCount *
                          state.pagination.prevPage +
                      1
                    : 0;
            state.pagination.currentLastItem =
                state.pagination.currentFirstItem > 0
                    ? state.pagination.currentFirstItem +
                      state.pagination.totalPerPage -
                      1
                    : 0;
        },
        searchableFields(state, fields) {
            state.searchableFields = fields;
            state.defaultSearchableFieldOption = fields[0].value;
        },
        statusSearchOptions(state, options) {
            state.statusSearchOptions = options;
            state.defaultStatusSearchOption = options[0].value;
        },
        defaultStatusSearchOption(state, value) {
            state.defaultStatusSearchOption = value;
        },
        defaultSearchableFieldOption(state, value) {
            state.defaultSearchableFieldOption = value;
        },
        searchKeyword(state, value) {
            state.searchKeyword = value;
        },
        setModal(state, param) {
            state.modal[param.type].status = param.status;
        },
        setDepositSlipImage(state, param) {
            state.depositSlipImage = param;
        },
        orderDetails(state, orderDetails) {
            state.orderDetails = orderDetails;
        },
        orderTransactionUuid(state, orderTransactionUuid) {
            state.orderTransactionUuid = orderTransactionUuid;
        },
        paymentTypeOptions(state, paymentTypeOptions) {
            state.paymentTypeOptions = paymentTypeOptions;
        },
        logisticsTypeOptions(state, logisticsTypeOptions) {
            state.logisticsTypeOptions = logisticsTypeOptions;
        },
        setPaymentExpressHistory(state, value) {
          state.paymentExpressHistory = value;
        },
        setPointsEarned(state, value) {
            state.pointsEarned = value;
        }
    },
    getters: {
        orderDetails: (state) => state.orderDetails
    },
    actions: {
        async getOrders({ commit }, param) {
            commit("loading");
            try {
                let response = await estoreOrder.getOrders(param);
                let ordersPointsEarnedPayload = {
                    order_uuids: response.list.map(order => order.uuid)
                };

                if (ordersPointsEarnedPayload.order_uuids.length != 0) {
                    await estoreOrder
                        .getOrdersPointsEarned(ordersPointsEarnedPayload)
                        .then(ordersPointsEarned => {
                            let pointsEarned = ordersPointsEarned.points_earned;
                            if (pointsEarned.length != 0) {
                                for (
                                    let index = 0;
                                    index < pointsEarned.length;
                                    index++
                                ) {
                                    const orderPointsEarned =
                                        pointsEarned[index];
                                    const orderWithPointsEarned = response.list.filter(
                                        order =>
                                            order.uuid ==
                                            orderPointsEarned.order_uuid
                                    );
                                    orderWithPointsEarned[0].points_earned = parseInt(
                                        orderPointsEarned.points
                                    );
                                }
                            }
                        });
                }

                if (param.page === 1) {
                    await commit("setInitialPageCount", response.list);
                }
                commit("orders", response.list);
                commit("setPagination", response);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Oops, cannot retrieve orders.");
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async exportHistory({ commit }, param) {
            commit("loading");
            commit("errors", null);

            try {
                let response = await estoreOrder.exportHistory(param);
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                notification.warning(
                    _.get(errors, "errors.message", "Oops, cannot export data.")
                );
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async getStatusOption({ commit }) {
            try {
                let response = await estoreOrder.getStatusOption();
                let statusOptions = advanceSearchHelper.buildOptionFor(
                    response.options,
                    "All Status"
                );
                let forPickUpOption = statusOptions.find(
                    status => status.text === "For Pickup"
                );
                // let inProcessOption = statusOptions.find(
                //     status => status.text === "In Process"
                // );
                // let deliveredOption = statusOptions.find(
                //     status => status.text === "Delivered"
                // );
                forPickUpOption.text = "Ready for Pickup";
                // inProcessOption.text = "Processing";
                // deliveredOption.text = "Claimed";
                // console.log(
                //     statusOptions.filter(function(el) {
                //         return el.text != "Ready for Pickup";
                //     })
                // );
                commit(
                    "statusSearchOptions",
                    statusOptions.filter(function(el) {
                        return el.text != "Ready for Pickup";
                    })
                );
            } catch (errors) {
                commit("errors", errors);
            }
        },
        async getSearchableFieldsOption({ commit }) {
            try {
                let response = await estoreOrder.getColumnsOption();
                let columnOptions = advanceSearchHelper.buildOptionFor(
                    response.options,
                    null
                );
                let paymentTypeOptions = advanceSearchHelper.buildOptionFor(
                    response.payment_type_options,
                    null
                );
                let logisticsTypeOptions = advanceSearchHelper.buildOptionFor(
                    response.logistics_type_options,
                    null
                );

                // Remove Mode of Payment and Logistics Type in column options
                // columnOptions.splice(-2)

                // let branchOriginOption = columnOptions.find(
                //     status => status.text === "Branch origin"
                // );
                // branchOriginOption.text = "Brand Branch";
                commit("searchableFields", columnOptions);
                commit("paymentTypeOptions", paymentTypeOptions);
                commit("logisticsTypeOptions", logisticsTypeOptions);
            } catch (errors) {
                commit("errors", errors);
            }
        },
        async updateStatus({ commit }, param) {
            commit("loading");
            try {
                let response = await estoreOrder.updateStatus(param);
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Oops, cannot update order.");
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async cancelOrder({ commit }, param) {
            commit("loading");
            try {
                let response = await estoreOrder.cancelOrder(param);
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Oops, cannot cancel order.");
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async getOrderTransactionDetails({ commit }, param) {
            commit("loading");
            commit("errors", null);

            try {
                const { list } = await estoreOrder.getOrderTransactionDetails(
                    param
                );
                
                commit("orderTransactionUuid", param.uuid);

                if (_.has(list, 'voucher_info') && isJSON(list.voucher_info)) { 
                    list.voucher_info = JSON.parse(list.voucher_info);
                }     

                commit("orderDetails", list);
                commit("loading", false);
            } catch (errors) {
                notification.warning(
                    "Oops, cannot retrieve transaction details."
                );
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async updateDepositSlipStatus({ commit }, param) {
            commit("loading");
            try {
                let response = await estoreOrder.updateDepositSlipStatus(param);
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                notification.warning(
                    "Oops, cannot update deposit slip status."
                );
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async getPaymentExpressHistory({ commit }, payload) {
          commit("loading", true);

          try {
            const response = await estoreOrder.getPaymentExpressHistory(payload);
    
            if (payload.page === 1) {
              await commit("setInitialPageCount", response.list);
            }
            commit("setPaymentExpressHistory", response.list);
            commit("setPagination", response);
          } catch (errors) {
            notification.warning("Oops, cannot get payment express history.");
            commit("errors", errors);
          } finally {
            commit("loading", false);
          }
        },
        async getPointsEarned({ commit }, payload) {
          commit("loading", true);
          commit("errors", null);
          commit("setPointsEarned", 0);

          try {
            const { points_earned } = await estoreOrder.getOrdersPointsEarned(payload);
    
            commit("setPointsEarned", parseInt(_.get(points_earned, "[0].points", 0)));
          } catch (errors) {
            commit(
                "errors",
                 _.get(errors, "errors.message", "Oops, something went wrong.")
            );
          } finally {
            commit("loading", false);
          }
        },
    }
};
